"use client";
import { Box } from "@mantine/core";
import clsx from "clsx";
import { ReactNode } from "react";
import classes from "./ResourceFilterAndBannerWrapper.module.css";

export default function ResourceFilterAndBannerWrapper({
  children,
  hasFilters,
}: {
  children: ReactNode;
  hasFilters: boolean;
}) {
  return (
    <Box
      className={clsx(classes.group, hasFilters && classes.groupHasFilters)}
    >
      {children}
    </Box>
  );
}
